import React, { useEffect } from "react";
import { LegalShell, Section } from "./LegalShell";

export default function AgbPage() {
  useEffect(() => {
    document.title = "Plantus · AGB";
  }, []);
  return (
    <LegalShell title="Allgemeine Geschäftsbedingungen" lastUpdated="Februar 2026" testId="agb-page">
      <Section title="§ 1 Geltungsbereich">
        <p>
          Diese Allgemeinen Geschäftsbedingungen (nachfolgend &bdquo;AGB&ldquo;) gelten für sämtliche Verträge
          zwischen Hoytec-Solutions, Inhaber René Hoyer, Neusornziger Straße 9, 04769 Mügeln
          (nachfolgend &bdquo;Anbieter&ldquo;) und seinen Kunden über die Nutzung der Software &bdquo;Plantus&ldquo;
          (nachfolgend &bdquo;Software&ldquo; oder &bdquo;Dienst&ldquo;).
        </p>
        <p>
          Plantus richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB. Verbraucher im
          Sinne des § 13 BGB sind von der Nutzung ausgeschlossen.
        </p>
      </Section>

      <Section title="§ 2 Vertragsgegenstand">
        <p>
          Der Anbieter stellt dem Kunden eine Software-as-a-Service-Lösung zur Dokumentation von
          Pflanzenschutzmittel-Anwendungen gemäß den Vorgaben des PflSchG, der EU 1107/2009 und
          der Durchführungsverordnung (EU) 2023/564 bereit. Der Kunde erhält für die Dauer des
          Vertrages ein nicht ausschließliches, nicht übertragbares Nutzungsrecht.
        </p>
      </Section>

      <Section title="§ 3 Vertragsschluss und Tarife">
        <p>
          Der Vertrag kommt mit Bestätigung der Registrierung zustande. Der Anbieter bietet einen
          kostenlosen Tarif (&bdquo;Free&ldquo;) mit begrenztem Funktionsumfang sowie kostenpflichtige
          Tarife (&bdquo;Pro&ldquo;) an. Die jeweils geltenden Preise und Leistungsumfänge sind auf der
          Website unter <a href="/preise" className="text-forest-700 hover:underline">/preise</a> einsehbar.
        </p>
      </Section>

      <Section title="§ 4 Laufzeit, automatische Verlängerung und Kündigung">
        <p>
          Kostenpflichtige Tarife werden jeweils für 12 Monate (365 Tage) abgeschlossen. Nach Ablauf der Laufzeit
          verlängert sich das Abonnement automatisch um jeweils weitere 12 Monate zu den zu diesem Zeitpunkt geltenden Preisen,
          sofern der Kunde nicht mit einer Frist von einem Monat zum Ende der jeweiligen Laufzeit kündigt.
        </p>
        <p>
          Die Kündigung erfolgt einfach und jederzeit über den Kunden-Bereich unter{" "}
          <a href="/app/abo" className="text-forest-700 hover:underline">/app/abo</a> mit einem Klick.
          Der Kunde wird zusätzlich 30 Tage vor der automatischen Verlängerung per E-Mail und In-App-Benachrichtigung
          über die anstehende Verlängerung informiert (§ 312k BGB analog).
        </p>
        <p>
          Der kostenlose Tarif ist jederzeit ohne Frist kündbar.
        </p>
      </Section>

      <Section title="§ 5 Zahlungsbedingungen">
        <p>
          Die Zahlung erfolgt im Voraus über die Zahlungsdienstleister Stripe Payments Europe Ltd.
          Akzeptierte Zahlungsmethoden sind insbesondere Kreditkarte und SEPA-Lastschrift, sowie
          weitere im Checkout angezeigte Methoden. Eine Rechnung wird nach Zahlungseingang
          elektronisch bereitgestellt.
        </p>
      </Section>

      <Section title="§ 6 Pflichten des Kunden">
        <p>
          Der Kunde ist verpflichtet, alle eingegebenen Daten wahrheitsgemäß und vollständig zu
          erfassen. Die rechtssichere Dokumentation gemäß PflSchG bleibt eine Pflicht des Kunden
          gegenüber den zuständigen Behörden; Plantus dient als Werkzeug zur Erfüllung dieser
          Pflicht.
        </p>
      </Section>

      <Section title="§ 7 Verfügbarkeit">
        <p>
          Der Anbieter strebt eine jährliche Verfügbarkeit von 99 % im Jahresmittel an. Wartungs-
          und Updatearbeiten werden, soweit möglich, außerhalb der Hauptnutzungszeiten
          durchgeführt. Ein Anspruch auf ununterbrochene Verfügbarkeit besteht nicht.
        </p>
      </Section>

      <Section title="§ 8 Haftung">
        <p>
          Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei
          Verletzung von Leben, Körper und Gesundheit. Bei einfacher Fahrlässigkeit haftet der
          Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten); die
          Haftung ist insoweit auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
        </p>
        <p>
          Eine Haftung für den behördlich anerkannten Inhalt der vom Kunden eingegebenen Daten ist
          ausgeschlossen.
        </p>
      </Section>

      <Section title="§ 9 Datenschutz">
        <p>
          Es gilt unsere Datenschutzerklärung unter{" "}
          <a href="/datenschutz" className="text-forest-700 hover:underline">/datenschutz</a>.
        </p>
      </Section>

      <Section title="§ 10 Schlussbestimmungen">
        <p>
          Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
          Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Anbieters. Sollten einzelne
          Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
        </p>
      </Section>
    </LegalShell>
  );
}
